import cssGlobal from '../../../utils/cssGlobal';
import 'primereact/components/common/Common.css';
import 'primereact/components/calendar/Calendar.css';

export default cssGlobal({
  '.fa-angle-left:before, .fa-angle-right:before': {
    marginLeft: -5
  }
});



// WEBPACK FOOTER //
// ./src/components/inputs/date/DateInput.styles.js